// extracted by mini-css-extract-plugin
export default {"content":"styles_content__gfXcT","item":"styles_item__UXcDi","label":"styles_label__4nwk8","rot":"styles_rot__rIVmz"};